import classNames from 'classnames/bind';

import Pipeline from 'types/pipeline';

import { useAppRedirect } from 'hooks/useAppRedirect';
import { useHasAccess } from 'hooks/useHasAccess';

import { NavRoute, DeployRoute } from 'application/types/routes';

import { PipelineTemplateGrid } from 'analytics-library/components/PipelineTemplateGrid/PipelineTemplateGrid';
import * as PageLayout from 'components/PageLayout';

import styles from './Solutions.module.scss';

const c = classNames.bind(styles);

export function Solutions() {
  const redirect = useAppRedirect();

  function handleDeployPipeline(pipeline: Pipeline) {
    sessionStorage.setItem('rapidDeployPreselectedPipelineId', pipeline.id);
    redirect({
      pathname: `/${NavRoute.DEPLOY}/${DeployRoute.RAPID_DEPLOY}`,
    });
  }

  const [hasAccess] = useHasAccess();
  const canDeploy = hasAccess('deploy');

  return (
    <PageLayout.Root className={c('solutions')}>
      <PipelineTemplateGrid
        id="library-templates"
        onDeployPipeline={canDeploy ? handleDeployPipeline : undefined}
        showPlanScopeFilter
      />
    </PageLayout.Root>
  );
}
